// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portfolio-items {
  display: flex;
  flex-direction: row; /* Default to row for desktop */
  justify-content: center;
  gap: 2rem;
  flex-wrap: wrap; /* Allows wrapping if needed */
}

.portfolio-item {
  padding: 3rem;
  max-width: 25rem; /* Ensure items don't stretch too wide */
}

.project {
  height: 30rem;
}

.project-text {
  width: 100%; /* Adjust to fit container */
  text-align: left;
  padding-left: 1rem;
}

@media (max-width: 768px) {
  .portfolio-section {
    padding-top: 20rem;
  }
  .portfolio-items {
    flex-direction: column; /* Stack items vertically */
    align-items: center; /* Center items for better alignment */
    gap: 3rem; /* Add spacing between stacked items */
  }

  .portfolio-item {
    padding: 1.5rem; /* Adjust padding for smaller screens */
  }

  .project {
    height: auto; /* Allow image height to adjust */
    max-width: 100%; /* Ensure image doesn't overflow */
  }

  .project-text {
    text-align: center; /* Center-align text on mobile */
    padding-left: 0; /* Remove extra padding */
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Portfolio.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB,EAAE,+BAA+B;EACpD,uBAAuB;EACvB,SAAS;EACT,eAAe,EAAE,8BAA8B;AACjD;;AAEA;EACE,aAAa;EACb,gBAAgB,EAAE,wCAAwC;AAC5D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW,EAAE,4BAA4B;EACzC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,sBAAsB,EAAE,2BAA2B;IACnD,mBAAmB,EAAE,sCAAsC;IAC3D,SAAS,EAAE,sCAAsC;EACnD;;EAEA;IACE,eAAe,EAAE,uCAAuC;EAC1D;;EAEA;IACE,YAAY,EAAE,iCAAiC;IAC/C,eAAe,EAAE,kCAAkC;EACrD;;EAEA;IACE,kBAAkB,EAAE,gCAAgC;IACpD,eAAe,EAAE,yBAAyB;EAC5C;AACF","sourcesContent":[".portfolio-items {\n  display: flex;\n  flex-direction: row; /* Default to row for desktop */\n  justify-content: center;\n  gap: 2rem;\n  flex-wrap: wrap; /* Allows wrapping if needed */\n}\n\n.portfolio-item {\n  padding: 3rem;\n  max-width: 25rem; /* Ensure items don't stretch too wide */\n}\n\n.project {\n  height: 30rem;\n}\n\n.project-text {\n  width: 100%; /* Adjust to fit container */\n  text-align: left;\n  padding-left: 1rem;\n}\n\n@media (max-width: 768px) {\n  .portfolio-section {\n    padding-top: 20rem;\n  }\n  .portfolio-items {\n    flex-direction: column; /* Stack items vertically */\n    align-items: center; /* Center items for better alignment */\n    gap: 3rem; /* Add spacing between stacked items */\n  }\n\n  .portfolio-item {\n    padding: 1.5rem; /* Adjust padding for smaller screens */\n  }\n\n  .project {\n    height: auto; /* Allow image height to adjust */\n    max-width: 100%; /* Ensure image doesn't overflow */\n  }\n\n  .project-text {\n    text-align: center; /* Center-align text on mobile */\n    padding-left: 0; /* Remove extra padding */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
